function initDocEvents() {
    $(window).on( 'resize orientationchange', addEndEvent );
    $(window).on( 'resizeEnd', resizeHandler );
    $(window).on( 'scroll', scrollHandler );
}

function events(wait, immediate, func ) {
    var timeout;

    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

var addEndEvent = events( 200, false, function(e) {
    $(this).trigger(e.type + 'End');
});